import {
  apiCollection,
  apiCollectionFiction,
  apiFiction,
} from "../api/api-models";
import * as tvx from "../lib/tvx-plugin-module.min";
import { MSXContentItem, MSXContentPage } from "../lib/tvx-plugin-module.min";
import { createContentRequest } from "../utils";
import {
  getCurrentlyDisplayingItemByIndex,
  getDisplayedItems,
} from "./content-utils";

const collectionsCorouselsPositions: Map<string, number> = new Map();
const collections: apiCollection[] = [];
export function getDestMovieByCollectionId(
  collectionId: string,
  itemIndex: string
): apiCollectionFiction {
  const movies = collections.find(
    (collection) => collection.id == collectionId
  ).collectionFictions;
  console.log(movies);

  const listIndex = collectionsCorouselsPositions.get(collectionId);
  console.log(listIndex);

  return getCurrentlyDisplayingItemByIndex(
    movies,
    listIndex,
    Number.parseInt(itemIndex)
  );
}
export function updateCollectionRow(collectionId: string, type: number): void {
  const collection = collections.find(
    (collection) => collection.id == collectionId
  );
  const oldIndex = collectionsCorouselsPositions.get(collectionId);
  const displaingFictions = getDisplayedItems(
    collection.collectionFictions,
    oldIndex,
    type
  );
  collectionsCorouselsPositions.set(collectionId, displaingFictions.newIndex);

  for (let i = 0; i < displaingFictions.items.length; i++) {
    const fiction = (displaingFictions.items[i] as apiCollectionFiction)
      .fiction;
    const movieOrSerial =
      fiction.kind == "movie" ? fiction.movie : fiction.serial;
    const fictionImage = movieOrSerial.portraitImage;
    tvx.InteractionPlugin.executeAction(
      `update:content:home-${collectionId}-${i + 1}`,
      {
        image: fictionImage,
        title: movieOrSerial.title.toUpperCase(),
      }
    );
  }

  tvx.InteractionPlugin.stopLoading();
}
export function createCollectionRow(collection: apiCollection): MSXContentPage {
  collectionsCorouselsPositions.set(collection.id, 0);
  collections.push(collection);
  const collectionRowPage: MSXContentPage = {
    headline: collection.name.toUpperCase(),
    items: [
      {
        type: "teaser",
        layout: `0,0,12,1`,
        title: collection.name,
        centration: "title",
        action:
          "content:" + createContentRequest(`collection:${collection.slug}`),
      },
      {
        id: `home-collection-${collection.id}-back`,
        type: "default",
        layout: `0,1,1,3`,
        display: collection.collectionFictions.length > 5,
        icon: "arrow-back-ios",
        iconSize: "small",
        action: `interaction:commit:message:content:fictions:collections:back:${collection.id}`,
      },
      {
        id: `home-collection-${collection.id}-forward`,
        type: "default",
        display: collection.collectionFictions.length > 5,
        layout: `11,1,1,3`,
        icon: "arrow-forward-ios",
        iconSize: "small",
        action: `interaction:commit:message:content:fictions:collections:forward:${collection.id}`,
      },
    ],
  };
  for (let i = 0; i < Math.min(5, collection.collectionFictions.length); i++) {
    collectionRowPage.items.push(
      createCollectionMovieItem(
        collection.id,
        collection.collectionFictions[i],
        i + 1
      )
    );
  }
  return collectionRowPage;
}

function createCollectionMovieItem(
  collecionID: string,
  fiction: apiCollectionFiction,
  index: number
): MSXContentItem {
  const object =
    fiction.fiction.kind == "movie"
      ? fiction.fiction.movie
      : fiction.fiction.serial;
  return {
    id: `home-${collecionID}-${index}`,
    type: "separate",
    layout: `${index * 2 - 1},1,2,4`,
    image: object.portraitImage,
    title: object.title.toUpperCase(),
    action:
      "content:" +
      createContentRequest(`fiction:collection:${collecionID}:${index}`),
  };
}
